import React from "react";
import { Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import "./index.less";

type props = {
  isOpen: boolean;
  onClose?: () => void;
  onYesClick?: () => void;
  onDelete?: () => void;
};

const CreatorSwitchBankAccountModalComponent: React.FC<props> = ({ isOpen, onClose, onYesClick, onDelete }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="bottom-modal-overlay" onClick={handleOverlayClick}>
      <div className="bottom-modal-content" onClick={handleModalClick}>
        <Row className="w-full justify-content-center mt-10">
          <div className="header-icon-grey" onClick={handleOverlayClick}></div>
        </Row>
        <div className="bottom-modal-header">
          <Typography.Text className="bottom-modal-title f-26">{t("payment-card")}</Typography.Text>
        </div>
        <div className="bottom-modal-body">
          <button className="bottom-modal-button" onClick={onYesClick}>
            <Typography.Text className="bottom-modal-button-title">{t("set-as-default")}</Typography.Text>
          </button>

          <button className="bottom-modal-button mt-14" onClick={onDelete}>
            <Typography.Text className="bottom-modal-button-title">{t("delete-this-card")}</Typography.Text>
          </button>

          <button className="bottom-modal-cancel-button" onClick={onClose}>
            <Typography.Text className="bottom-modal-cancel-button-title">{t("cancel")}</Typography.Text>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreatorSwitchBankAccountModalComponent;
